import React from "react";
import { status, inboxStatus } from "venuescanner-js/constants/thread";
import UserTypes from "venuescanner-js/constants/user_type";
export const getStatus = (enquiryStatus) => {
  switch (enquiryStatus) {
    case inboxStatus.NEW:
      return inboxStatus.NEW;
    case inboxStatus.OPEN:
      return inboxStatus.OPEN;
    case status.POSTPONED:
      return inboxStatus.CLOSED;
    case status.ACCEPTED:
      return status.ACCEPTED;
    case inboxStatus.BOOKED:
      return inboxStatus.BOOKED;
    case status.BOOKED_BY_HOST:
      return inboxStatus.BOOKED;
    case status.BOOKED_BY_ORG:
      return inboxStatus.BOOKED;
    case status.EXPIRED:
      return inboxStatus.CLOSED;
    case status.DECLINED:
      return inboxStatus.CLOSED;
    case status.CANCELLED:
      return inboxStatus.CLOSED;
    case inboxStatus.CLOSED:
      return inboxStatus.CLOSED;
    case status.CLOSED_BY_HOST:
      return inboxStatus.CLOSED;
    case status.CLOSED_OTHER_BOOKED:
      return inboxStatus.CLOSED;
    case status.CLOSED_EVENT_OPEN:
      return inboxStatus.CLOSED;
    case status.CLOSED_EVENT:
      return inboxStatus.CLOSED;
    default:
      return null;
  }
};
const appendText = (enquiryStatus, viewerRole) => {
  switch (enquiryStatus) {
    case status.BOOKED_BY_ORG:
      return viewerRole === UserTypes.host ? "?" : "";
    default:
      return "";
  }
};
const EnquiryStatus = ({ enquiryStatus, thread }) => {
  if (!enquiryStatus && thread) enquiryStatus = thread.status.toLowerCase();
  const currentStatus = getStatus(enquiryStatus);
  const additionalText = thread
    ? appendText(enquiryStatus, thread.viewerRole)
    : "";
  return (
    <div className={`enquiry-status enquiry-status--${currentStatus}`}>
      {`${currentStatus}${additionalText}`}
    </div>
  );
};

export default EnquiryStatus;
